export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13596.55705dad.jpg";